export const driversColumns = (t: any) => [
    {
      key: "lastName",
      name: t('drivers.columns.lastName'),
      fieldName: "lastName",
      minWidth: 250,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "firstName",
      name: t('drivers.columns.firstName'),
      fieldName: "firstName",
      minWidth: 100,
      maxWidth: 100,
    },
    {
      key: "phone",
      name: t('drivers.columns.phone'),
      fieldName: "phone",
      minWidth: 200,
      maxWidth: 250,
    },
  ];